export const SLICE_NAME = 'clover';
